module.exports = __webpack_public_path__ + "static/1-b177b7ff2a1ae9146ae950a8fbf6c365.jpg";